import React from 'react';
import PropTypes from 'prop-types';
import './UniversalLineWithComponents.css';

function UniversalLineWithComponents({ leftSide, rightSide, basicStyle = 'line-with-components' }) {
  const renderComponent = (item, index) => {
    const { component: Component, props } = item;

    if (!Component) {
      console.error(`Invalid component at index ${index}:`, item);
      return null; // Pomiń element, jeśli nie ma komponentu
    }

    return <Component key={index} {...props} />;
  };

  return (
    <div className={basicStyle}>
      {/* Lewa strona */}
      <div className="left-side">
        {leftSide.map((item, index) => renderComponent(item, index))}
      </div>

      {/* Prawa strona */}
      <div className="right-side">
        {rightSide.map((item, index) => renderComponent(item, index))}
      </div>
    </div>
  );
}

UniversalLineWithComponents.propTypes = {
  leftSide: PropTypes.arrayOf(
    PropTypes.shape({
      component: PropTypes.elementType.isRequired, // Komponent do wyrenderowania
      props: PropTypes.object, // Właściwości przekazywane do komponentu
    })
  ).isRequired,
  rightSide: PropTypes.arrayOf(
    PropTypes.shape({
      component: PropTypes.elementType.isRequired, // Komponent do wyrenderowania
      props: PropTypes.object, // Właściwości przekazywane do komponentu
    })
  ).isRequired,
  basicStyle: PropTypes.string, // Klasa podstawowego wyglądu dla głównego elementu
};

UniversalLineWithComponents.defaultProps = {
  basicStyle: 'line-with-components', // Domyślna wartość dla basicStyle
};

export default UniversalLineWithComponents;